module.exports = __webpack_public_path__ + "img/02.3ade6ccc.png";